// extracted by mini-css-extract-plugin
export var container = "Layout-module--container--zjS0m";
export var footer = "Layout-module--footer--70+aq";
export var mainPane = "Layout-module--mainPane--PrPKl";
export var headerRssContainer = "Layout-module--headerRssContainer--0wzt0";
export var LeftSideSection = "Layout-module--LeftSideSection--X7NOJ";
export var RightSideSection = "Layout-module--RightSideSection--fz4s1";
export var newText = "Layout-module--newText--NreYh";